import axios from "axios";

import { passengerValidationApiPrefix } from "../../paths";
import {
  PassengersResponse,
  PassengersForFareRequest,
  NETWORK_CALL_FAILED,
  IApiConfig,
} from "@hopper-b2b/types";
import { trackEvent } from "@hopper-b2b/api";

const END_POINT = `${passengerValidationApiPrefix}`;

export const validatePassengers = (
  req: PassengersForFareRequest,
  apiConfig?: IApiConfig
): Promise<PassengersResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(END_POINT, req);

      const responseBody = res.data;
      resolve(responseBody);
    } catch (e) {
      trackEvent(
        {
          eventName: NETWORK_CALL_FAILED,
          properties: {
            url: window.location.pathname,
          },
        },
        apiConfig
      );
      reject(e);
    }
  });
